import React, {Component} from "react";
import ASLInductAreaContextProvider from "./context/ASLInductAreaContext";
import ASLInductArea from "./ASLInductArea";
import CapabilityContextProvider from "../global/context/ConfigContext";

class Technician extends Component {
    render() {
        return (
            <CapabilityContextProvider>
            <ASLInductAreaContextProvider>
                <ASLInductArea/>
            </ASLInductAreaContextProvider>
            </CapabilityContextProvider>
        )
    }
}

export default Technician


// WEBPACK FOOTER //
// ./src/components/technician/Technician.js